import { writable } from 'svelte/store';
export const isScreenSharingStore = writable(false);
